import axios from "axios";
import {API_URL} from "../App";
import authService from "./AuthService";
import {saveAs} from 'file-saver';

export function download(fileName, path, sendAlertMessage, onFinish, ids) {

    const headers = {'Authorization': 'Bearer ' + authService.getCurrentUser().accessToken};

    axios({
        url: API_URL + path,
        params: {fileName: fileName, ...(ids ? { ids: ids.join(',') } : {})},
        method: 'GET',
        responseType: 'blob',
        headers: headers,
    })
        .then(response => {
            const contentType = response.headers['content-type'];
            const blob = new Blob([response.data], {type: contentType});
            const url = window.URL.createObjectURL(blob);

            const providedName = response.headers['content-disposition']?.match(/filename="([^"]+)"/)[1];

            if (contentType === 'application/pdf' || contentType.startsWith('image/')) {
                window.open(url)
            } else {
                saveAs(blob, providedName || fileName);
                sendAlertMessage('Fájl sikeresen letöltve')
            }
        })
        .catch(error => {
            console.error(error)
            sendAlertMessage('Fájl letöltése sikertelen', 'error')
        })
        .finally(() => {
            if (onFinish) onFinish()
        })
}


export async function getFileUrl(fileName, path) {
    try {
        const headers = {
            Authorization: 'Bearer ' + authService.getCurrentUser().accessToken
        };

        const response = await axios({
            url: API_URL + path,
            method: 'GET',
            params: { fileName },
            responseType: 'blob',
            headers,
        });

        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], { type: contentType });
        const objectUrl = window.URL.createObjectURL(blob);

        return objectUrl; // <-- use this in <img src={url} />
    } catch (err) {
        console.error("Failed to load file:", err);
        return null;
    }
}

export const uploadFiles = async (url, files, handleFinish, sendAlertMessage, request) => {
    const formData = new FormData();
    if (request != null) formData.append('request', new Blob([JSON.stringify(request)], {type: "application/json"}));
    files.forEach((file) => {
        formData.append('files', file);
    });
    const headers = {Authorization: `Bearer ${authService.getCurrentUser().accessToken}`};

    try {
        await axios.post(API_URL + url, formData, {headers})
        sendAlertMessage('Fájlok sikeresen feltöltve');
        handleFinish();
    } catch (error) {
        sendAlertMessage(error?.response?.data?.message || 'Fájl(ok) feltöltése sikertelen', 'error');
    }
};
